<template>
  <div>
    <a-card>
      <div class="table-page-search-wrapper">  <a-form :form="form" layout="inline">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-item label="企业名称">
              <a-select
                show-search
                placeholder=" "
                option-filter-prop="children"
                allowClear
                v-model="queryParam.enterpriseId"
                :filter-option="filterOption">
                <a-select-option :value="item.enterpriseId" v-for="item in dxEnterprise" :key="item.enterpriseId">
                  {{ item.enterpriseName }}
                </a-select-option>
              </a-select>
            </a-form-item></a-col>
          <a-col :span="6">
            <a-form-item label="品牌" >
              <a-select
                v-model="queryParam.brandId"
                allowClear="true"
                showSearch
                optionFilterProp="children"
                :filterOption="filterOption">
                <a-select-option v-for="item in data4" :title="item.brandName" :value="item.brandId">{{
                  item.brandName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="型号" >
              <a-select
                v-model="queryParam.modelId"
                allowClear="true"
                showSearch
                optionFilterProp="children"
                :filterOption="filterOption">
                <a-select-option v-for="item in data3" :title="item.brandName" :value="item.modelId">{{
                  item.modelName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="CTEI码">
              <a-input v-model="queryParam.cteiNumber" type="number" oninput="if(value.length>16)value=value.slice(0,16)" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-button type="primary" @click="search">
            搜索
          </a-button>
          <a-button style="margin-left: 8px" @click="empty()">清空</a-button>
          <a-button class="ml-20" type="primary">
            <a href="/CTEI.xls" download="CTEI导入模板.xls" style="text-decoration: none">下载导入模板</a>
          </a-button>
          <a-upload
            style="display:inline-block"
            class="mlr-20"
            name="file"
            :action="uploadUrl"
            :headers="headers"
            @change="handleChange"
            :showUploadList="false">
            <a-button type="primary"> 导入Excel </a-button>
          </a-upload>
          <a-button type="primary" @click="exportEnt">
            导出
          </a-button>
        </a-row>
      </a-form></div>

      <a-table
        size="middle"
        :columns="columns"
        :data-source="list"
        class="mtb-30"
        @change="handleTableChange"
        :pagination="false">
        <template slot="operation" slot-scope="text, record">
          <a-popconfirm title="确定删除吗?" @confirm="() => del(record)">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </a-table>
      <a-pagination
        v-if="list.length > 0"
        class="flex_r"
        @change="onChangePage"
        v-model="current"
        :total="total"
        show-less-items />
    </a-card>
  </div>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import {
  selectbrand, selectmodel
} from '@/api/accessory/accessory'
import { getDxEnterpriseList, getCteiList, delCtei } from '@/api/order/orderList'
export default {
  data () {
    return {
      current: 1,
      total: 20,
      dxEnterprise: [],
      enterpriseId: '',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      // 查询参数
      queryParam: {
        cteiNumber: '',
        modelId: '',
        brandId: ''

      },
      uploadUrl: '/api/system/ctei/batchCTEIImport',
      columns: [
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          key: 'enterpriseName'
        },
        {
          title: '品牌名称',
          dataIndex: 'brandName',
          key: 'brandName'
        },
        {
          title: '型号名称',
          dataIndex: 'modelName',
          key: 'modelName'
        },
        {
          title: 'CTEI码',
          dataIndex: 'ctei',
          key: 'ctei'
        },
        {
          title: ' 操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      list: [],
      // 品牌列表
      data4: [],
      // 型号列表
      data3: []
    }
  },
  mounted () {
    // 电信——企业名称
    getDxEnterpriseList({
      type: 0
    }).then(res => {
      this.dxEnterprise = res.data
    })

    this.getList()
    // 查询品牌
    selectbrand().then(res => {
      this.data4 = res.rows
    })
    // 查询型号
    selectmodel().then(res => {
      this.data3 = res.rows
    })
  },
  methods: {
    del (record) {
      delCtei({ ctei: record.ctei }).then(res => {
        if (res.code == 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    empty () {
      this.queryParam = {}
      this.getList()
    },
    search () {
      this.current = 1
      this.getList()
    },
    getList () {
      getCteiList({
        pageSize: 10,
        pageNum: this.current,
        ...this.queryParam
      }).then(res => {
        this.list = res.rows
        this.total = res.total
      })
    },
    onChangePage (page) {
      this.current = page
      this.getList()
    },
    // 导入
    handleChange (info) {
      console.log(11111111111, info, info.file.response)
      if (info.file.status === 'done') {
        if (info.file.response.code == 500) {
          this.$message.error(info.file.response.msg)
        } else {
          this.$message.success('导入成功')
          this.enterpriseId = ''
          this.search()
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 导入失败`)
      }
    },
    // 导出
    exportEnt () {
      this.$axios({
        method: 'get',
        url: '/api/system/ctei/exportCtei',
        params: {
          enterpriseId: this.enterpriseId,
          cteiNumber: this.queryParam.cteiNumber,
          modelId: this.queryParam.modelId,
          brandId: this.queryParam.brandId
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        if (res.data.code == 500) {
          this.$message.error(res.data.msg)
        } else {
          var str = `/api/system/ctei/exportCtei?enterpriseId=${this.enterpriseId}&token=${this.headers.token}&cteiNumber=${this.queryParam.cteiNumber}&modelId=${this.queryParam.modelId}&brandId=${this.queryParam.brandId}`
          console.log(str)
          window.open(str)
        }
      })
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>
<style lang="less" scoped>

</style>
